import Label from '@/shared/components/Label';

type ContactUsLabelProps = {
  htmlFor: string;
  label: string;
};

function ContactUsLabel({htmlFor, label}: ContactUsLabelProps) {
  return (
    <Label
      htmlFor={htmlFor}
      className="font-semibold text-dark-gray text-xs sm:text-sm"
    >
      {label}
    </Label>
  );
}

export default ContactUsLabel;
